export default __webpack_public_path__ + "static/media/Sruthi J1.468086fe.jpg";